import BeautyFilterSlider from 'components/beautyFilter/BeautyFilterSlider';
import BeautyFilterTitle from 'components/beautyFilter/BeautyFilterTitle';
import BeautyFilterTabs from 'components/beautyFilter/BeautyFilterTabs';
import BeautyFilterMenu from 'components/beautyFilter/BeautyFilterMenu';

const BeautyFilterOverlay: React.FC = () => {
  return (
    <div className="absolute bottom-0 z-[11] flex w-full flex-col rounded-t-lg bg-[var(--bk-300)] text-base-txt-white">
      <BeautyFilterSlider />
      <BeautyFilterTitle />
      <BeautyFilterTabs />
      <BeautyFilterMenu />
    </div>
  );
};

export default BeautyFilterOverlay;
